import { connect } from 'react-redux';

import Main from '../components/Main';
import { isApplicationReady } from '../reducers/analyticsApp';

const mapStateToProps = (state) => ({
  applicationReady: isApplicationReady(state),
});

export default connect(mapStateToProps)(Main);
